import $ from "jquery";



$(function() {
    // handle submit event of form

        if($('#password-auto-generate')){
            setTimeout(function(){
                $('#password-auto-generate').hide();
            }, 400)

        }


        function builderror(errors, $form){

            grecaptcha.reset();
            // Vide la liste des erreurs
            $form.find('#errors-listregister > ul').html('');

            $.each(errors, function (key, value) {
                $form.find('#errors-listregister > ul').append($("<li>").text(value));
            });

            var c = $('.g-recaptcha').length;
            for (var i = 0; i < c; i++)
                grecaptcha.reset(i);

        }

        $(document).on("submit", "#registerform", function() {
            var e = this;

            var res = $(this).find('.g-recaptcha-response').val();

            if (res == "" || res == undefined || res.length == 0){
                builderror({"recaptcha":["Veuillez cliquer sur 'Je ne suis pas un robot'."]}, $(e));
                return false;
            }

            // change login button text before ajax
            var bouton = $(this).find("button[type='submit']");
            bouton.data("ancienTexte", bouton.text());

            // Remplacer le texte du bouton par "Veuillez patienter"
            bouton.prop("disabled", true).text("Veuillez patienter");

            let action = $(this).attr('action');
            $.post(action, $(this).serialize(), function(data) {

                window.location.reload()
            }).fail(function(response) {

                builderror($.parseJSON(response.responseText), $(e));
                bouton.prop( "disabled", false );
                console.log(bouton.data("ancienTexte"));
                bouton.text(bouton.data("ancienTexte"))

                console.log(response);
                console.log($(e));
            });
        return false;
        });
});
